import React from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

const item = ({ isActive }) =>
  `flex items-center gap-3 px-4 py-3 text-sm border-l-2 transition-colors ${
    isActive
      ? "border-oxblood text-ink bg-parchment"
      : "border-transparent text-sub hover:text-ink hover:bg-parchment"
  }`;

export default function DashboardLayout({ children, testid = "dashboard" }) {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const isAdmin = user?.role === "admin";
  const isSeller = user?.party_type === "seller";

  return (
    <div className="min-h-screen bg-parchment2 flex" data-testid={testid}>
      <aside className="w-72 shrink-0 hidden md:flex flex-col border-r border-line bg-parchment2">
        <Link to="/" className="px-6 py-6 flex items-center gap-3 border-b border-line">
          <div className="w-8 h-8 bg-oxblood text-parchment flex items-center justify-center h-serif">C</div>
          <div className="leading-tight">
            <div className="h-serif text-lg text-ink">Campbell&apos;s</div>
            <div className="overline -mt-0.5">Brokerage Desk</div>
          </div>
        </Link>
        <nav className="py-4 flex-1">
          {isSeller && !isAdmin ? (
            <>
              <div className="px-4 overline text-sub !text-sub mb-2">Supplier desk</div>
              <NavLink to="/dashboard/supplier" end className={item} data-testid="side-supplier-overview">Overview</NavLink>
              <NavLink to="/dashboard/compliance" className={item} data-testid="side-compliance">Compliance &amp; KYC</NavLink>
              <NavLink to="/dashboard/supplier-profile" className={item} data-testid="side-supplier-profile">Trade Profile</NavLink>
              <NavLink to="/dashboard/supplier-agreements" className={item} data-testid="side-supplier-agreements">Sign Agreements</NavLink>
            </>
          ) : (
            <>
              <div className="px-4 overline text-sub !text-sub mb-2">Deal flow</div>
              <NavLink to="/dashboard" end className={item} data-testid="side-overview">Overview</NavLink>
              <NavLink to="/dashboard/compliance" className={item} data-testid="side-compliance">Compliance &amp; KYC</NavLink>
              <NavLink to="/dashboard/deals" className={item} data-testid="side-deals">ICPO Intake / Deals</NavLink>
              <NavLink to="/dashboard/logistics" className={item} data-testid="side-logistics">Logistics Calculator</NavLink>
            </>
          )}
          {isAdmin && (
            <>
              <div className="px-4 overline text-sub !text-sub mt-6 mb-2">Administration</div>
              <NavLink to="/admin" end className={item} data-testid="side-admin-users">Pending Accounts</NavLink>
              <NavLink to="/admin/compliance" className={item} data-testid="side-admin-compliance">KYC Review</NavLink>
              <NavLink to="/admin/deals" className={item} data-testid="side-admin-deals">All Deals</NavLink>
            </>
          )}
        </nav>
        <div className="border-t border-line p-5">
          <div className="text-xs font-mono text-sub">SIGNED IN</div>
          <div className="text-sm text-ink mt-1 truncate">{user?.name}</div>
          <div className="text-xs text-sub truncate">{user?.email}</div>
          <button
            onClick={async () => { await logout(); nav("/"); }}
            className="mt-4 text-xs text-oxblood hover:text-oxblood-hover"
            data-testid="side-logout"
          >
            Sign out →
          </button>
        </div>
      </aside>
      <main className="flex-1 min-w-0">{children}</main>
    </div>
  );
}
